export { default as Subheading } from './Subheading';
export * from './useSubheading';